import { v4 as uuidv4 } from 'uuid';
import { LOCAL_STORAGE_KEYS, EVENT_NAMES, COOKIES } from './constants';
import * as Sentry from '@sentry/sveltekit';
import { ApiService } from '$lib/services/api';
import Cookies from 'js-cookie';

// TODO: review and standardize browser logic.
const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

let fetchFunc;
if (isBrowser) {
	fetchFunc = fetch;
} else {
	fetchFunc = globalThis.fetch;
}

let inMemoryStorage = {};

const getLocalStorageItem = (key) => {
	if (isBrowser) {
		return localStorage.getItem(key);
	} else {
		const event = {
			event_type: EVENT_NAMES.DEBUG,
			event_payload: {
				event_source: 'device-id.js - getLocalStorageItem',
				key,
				storage: inMemoryStorage
			}
		};
		try {
			ApiService.eventLog({ event }, fetchFunc);
		} catch (err) {
			Sentry.captureException('Device ID getLocalStorageItem error', {
				extra: {
					errors: err
				}
			});
		}
		return inMemoryStorage[key] || null;
	}
};

const setLocalStorageItem = (key, value) => {
	if (isBrowser) {
		localStorage.setItem(key, value);
	} else {
		const event = {
			event_type: EVENT_NAMES.DEBUG,
			event_payload: {
				event_source: 'device-id.js - setLocalStorageItem',
				key,
				storage: inMemoryStorage,
			}
		};
		try {
			ApiService.eventLog({ event }, fetchFunc);
		} catch (err) {
			Sentry.captureException('Device ID setLocalStorageItem error', {
				extra: {
					errors: err
				}
			});
		}
		inMemoryStorage[key] = value;
	}
};

export const getDeviceId = () => {
	let savedDeviceId = '';

	if (isBrowser) {
		const searchParams = new URLSearchParams(window.location.search);
		if (searchParams.has('device_id')) {
			savedDeviceId = searchParams.get('device_id') || '';
			setLocalStorageItem(LOCAL_STORAGE_KEYS.DEVICE_ID, savedDeviceId);
			Cookies.set(COOKIES.DEVICE_ID, savedDeviceId);
		} else {
			savedDeviceId = getLocalStorageItem(LOCAL_STORAGE_KEYS.DEVICE_ID);
		}
	} else {
		const uuid = uuidv4() + '-local_storage_fallback';

		const localStorageDeviceId = getLocalStorageItem(LOCAL_STORAGE_KEYS.DEVICE_ID);
		const cookiesDeviceId = Cookies.get(COOKIES.DEVICE_ID);

		savedDeviceId =
			localStorageDeviceId ? localStorageDeviceId :
			cookiesDeviceId ? cookiesDeviceId :
			uuid;

		const event = {
			event_type: EVENT_NAMES.DEBUG,
			event_payload: {
				device_id: savedDeviceId,
				event_source: 'device-id.js - local_storage_fallback',
				storage: inMemoryStorage,
			}
		};
		try {
			ApiService.eventLog({ event }, fetchFunc);
		} catch (err) {
			Sentry.captureException('Device ID local_storage_fallback error', {
				extra: {
					errors: err
				}
			});
		}
	}


	if (savedDeviceId) {
		return savedDeviceId;
	}

	const deviceId = uuidv4();
	setLocalStorageItem(LOCAL_STORAGE_KEYS.DEVICE_ID, deviceId);
	Cookies.set(COOKIES.DEVICE_ID, deviceId);
	Sentry.setTag('device_id', deviceId);
	Sentry.setUser({ id: deviceId });
	return deviceId;
};
